import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFormValues, change } from 'redux-form';
import { get } from 'lodash';

import { ReportGeneration } from 'Common/ObjectHelper';
import { toastType, createToast } from 'Common/ToastHelper';
import { Filter, Main } from 'Containers/';
import { VerificationReportForm } from './components/VerificationReportForm';
import { VerificationReportFieldEnum as Fields } from 'Common/FieldEnum';
import { VERIFICATION_REPORT_FORM_NAME } from 'Common/FormEnum';
import {
  getVerificationReport,
  clearReport,
  getInitialData,
  getVerificationCollection,
  writeVerificationCollection,
  getStatusByFiscalYear,
} from './state/verificationreport/actions';
import { getControlInfo } from 'State/controlInfo/actions';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { ReportEnum, Nov15thStatusEnum } from './helpers/constants';

class VerificationReportContainer extends Component {
  componentDidMount() {
    this.props.getInitialData();
    this.props.getControlInfo();
  }

  getMainProps = () => {
    const { loading } = this.props;

    return {
      toolbox: {
        formName: VERIFICATION_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;

    if (prevProps.report !== report && report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Verification Reports');
      }
      this.props.clearReport();
    }
  }

  handleSubmit = formValues => {
    if (formValues[Fields.Report] === ReportEnum.Summary) {
      const status = formValues[Fields.VerificationCompleted]
        ? formValues[Fields.VerificationCompletedByNov15]
          ? Nov15thStatusEnum.YesCompletedByNov15th
          : Nov15thStatusEnum.YesCompletedAfterNov15th
        : Nov15thStatusEnum.NoVerificationNotPerformedOrCompleted;

      this.props.writeVerificationCollection({
        ...formValues,
        Status: status,
      });
    }

    this.props.getVerificationReport(
      formValues[Fields.SiteCount],
      formValues[Fields.Report],
      formValues[Fields.FiscalYear]
    );
  };

  render() {
    const {
      formValues,
      loading,
      siteCount,
      controlInfo,
      fiscalYears,
      status,
      change,
      verificationCollection,
      getVerificationCollection,
      getStatusByFiscalYear,
    } = this.props;

    return fiscalYears === [] || siteCount === null || !controlInfo ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter title={'Verification Reports'} />
        <Main {...this.getMainProps()}>
          <VerificationReportForm
            onSubmit={this.handleSubmit}
            initialValues={{
              ...verificationCollection,
              [Fields.Report]: get(
                formValues,
                Fields.Report,
                ReportEnum.NoReport
              ),
              [Fields.SiteCount]: siteCount,
              [Fields.FiscalYear]: get(
                formValues,
                Fields.FiscalYear,
                controlInfo.FiscalYear
              ),
              [Fields.SchoolsNotRequired]: get(
                formValues,
                Fields.SchoolsNotRequired,
                false
              ),
              [Fields.SchoolsExempt]: get(
                formValues,
                Fields.SchoolsExempt,
                false
              ),
              [Fields.VerificationCompleted]: get(
                formValues,
                Fields.VerificationCompleted,
                false
              ),
              [Fields.VerificationCompletedByNov15]: get(
                formValues,
                Fields.VerificationCompletedByNov15,
                false
              ),
            }}
            loading={loading}
            formValues={formValues}
            fiscalYears={fiscalYears}
            status={status}
            change={change}
            siteCount={siteCount}
            getVerificationCollection={getVerificationCollection}
            getStatusByFiscalYear={getStatusByFiscalYear}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues(VERIFICATION_REPORT_FORM_NAME)(state),
    loading: state.VerificationReportState.verificationReport.loading,
    report: state.VerificationReportState.verificationReport.report,
    siteCount: state.VerificationReportState.verificationReport.siteCount,
    fiscalYears: state.VerificationReportState.verificationReport.fiscalYears,
    controlInfo: state.CommonState.controlInfo.data,
    status: state.VerificationReportState.verificationReport.status,
    verificationCollection:
      state.VerificationReportState.verificationReport.verificationCollection,
  };
};

export const VerificationReport = withRouter(
  connect(
    mapStateToProps,
    {
      getVerificationReport,
      clearReport,
      getControlInfo,
      getInitialData,
      change,
      getVerificationCollection,
      writeVerificationCollection,
      getStatusByFiscalYear,
    }
  )(VerificationReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/verificationreport/VerificationReport.js